// The languages the apps ship in, which are the languages the site can be read
// in. `name` is the language's own name for itself, the way the menu lists it.
// `code` is what goes in <html lang>, and names the strings file and the folder
// of localized store images.
export const LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'it', name: 'Italiano' },
    { code: 'nl', name: 'Nederlands' },
    { code: 'pt-BR', name: 'Português (Brasil)' },
    { code: 'ar', name: 'العربية', dir: 'rtl' },
    { code: 'ko', name: '한국어' },
    { code: 'ja', name: '日本語' },
    { code: 'zh-Hans', name: '简体中文' }
]

export const DEFAULT_LANGUAGE = 'en';

export const findLanguage = code => LANGUAGES.find(language => language.code === code)

// Picks the first of the browser's preferred languages the site has. Any
// Portuguese reads the Brazilian strings. Chinese has only Simplified, so
// Traditional (zh-Hant, zh-TW, zh-HK) is passed over for the next preference.
export const matchLanguage = tags => {
    for (const tag of tags) {
        const lower = (tag || '').toLowerCase();
        const base = lower.split('-')[0];

        if (base === 'zh') {
            if (!/^zh-(hant|tw|hk|mo)/.test(lower)) {
                return 'zh-Hans'
            }
            continue
        }

        if (base === 'pt') {
            return 'pt-BR'
        }

        const match = findLanguage(base);

        if (match) {
            return match.code
        }
    }

    return DEFAULT_LANGUAGE
}
